package lacaravana.domain

import lacaravana.app.Database

data class StockItemData(val menuItemId: String, val nombre: String, val cantidad: Int)

object Stock {
    suspend fun all(db: Database): List<StockItemData> =
        db.query("""
            SELECT mi.id, mi.nombre, COALESCE(s.cantidad, 0)
            FROM menu_items mi LEFT JOIN stock s ON mi.id = s.menu_item_id
            ORDER BY mi.nombre
        """).map { row ->
            StockItemData(
                menuItemId = row[0] as String,
                nombre = row[1] as String,
                cantidad = (row[2] as Number).toInt()
            )
        }

    suspend fun setQuantity(db: Database, menuItemId: String, cantidad: Int) {
        val existing = db.query("SELECT menu_item_id FROM stock WHERE menu_item_id = ?", arrayOf(menuItemId))
        if (existing.isEmpty()) {
            db.execute("INSERT INTO stock (menu_item_id, cantidad) VALUES (?, ?)", arrayOf(menuItemId, cantidad))
        } else {
            db.execute("UPDATE stock SET cantidad = ?, updated_at = datetime('now') WHERE menu_item_id = ?", arrayOf(cantidad, menuItemId))
        }
    }

    suspend fun adjust(db: Database, menuItemId: String, delta: Int) {
        val current = db.query("SELECT COALESCE(cantidad, 0) FROM stock WHERE menu_item_id = ?", arrayOf(menuItemId))
        val currentQty = if (current.isEmpty()) 0 else (current[0][0] as Number).toInt()
        val newQty = maxOf(0, currentQty + delta)
        setQuantity(db, menuItemId, newQty)
    }
}
